export enum BodyCompositions {
  Obesity = 0,
  Overweight = 1,
  Normal = 2,
  Muscular = 3,
}
